export default __webpack_public_path__ + "static/media/essential-plan-expiring.6e16d17e.svg";